var map = {
	"./activities.svg": 5556,
	"./art-classes.svg": 875,
	"./central-kitchen.svg": 8147,
	"./chess.svg": 532,
	"./computer-classes.svg": 203,
	"./elevator.svg": 6584,
	"./elimination-diets.svg": 9329,
	"./entrance-for-disabled.svg": 8960,
	"./garden.svg": 8980,
	"./integration.svg": 5070,
	"./languages.svg": 9754,
	"./milk-cousine.svg": 7928,
	"./outdoor-terrace.svg": 2494,
	"./parking.svg": 8038,
	"./playground.svg": 1249,
	"./religion.svg": 4361,
	"./rhythmics.svg": 866,
	"./separate-building.svg": 1537,
	"./sports.svg": 9671,
	"./theater-classes.svg": 8021,
	"./trolley-room.svg": 7918,
	"./wheelchair-ramp.svg": 4284
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1605;